<template>
  <div>
    <LoadingState v-if="loading" />
    <div class="nocanny" v-if="noCanny">
      Feedback is not available at this time
    </div>
    <div data-canny />
  </div>
</template>

<script>
import { onMounted, ref } from "@vue/composition-api";
import LoadingState from "@/components/display/LoadingState";
import store from "@/store";

export default {
  name: "Feedback",
  props: {
    boardId: String,
  },
  components: {
    LoadingState,
  },
  setup(props, { root }) {
    const loading = ref(true);
    const noCanny = ref(false);

    const executeCanny = (token, url, boardToken) => {
      !(function (w, d, i, s) {
        function l() {
          if (!d.getElementById(i)) {
            var f = d.getElementsByTagName(s)[0],
              e = d.createElement(s);
            (e.type = "text/javascript"),
              (e.async = !0),
              (e.src = "https://canny.io/sdk.js"),
              f.parentNode.insertBefore(e, f);
          }
        }
        if ("function" != typeof w.Canny) {
          var c = function () {
            c.q.push(arguments);
          };
          (c.q = []),
            (w.Canny = c),
            "complete" === d.readyState
              ? l()
              : w.attachEvent
              ? w.attachEvent("onload", l)
              : w.addEventListener("load", l, !1);
        }
      })(window, document, "canny-jssdk", "script");

      Canny("render", {
        boardToken,
        basePath: `/feedback/${url}`,
        ssoToken: token,
      });
    };

    const boardUrl = props.boardId ? props.boardId.split("/")[1] : null;

    onMounted(() => {
      store.dispatch("settings/fetchCanny").then((data) => {
        console.log(data, boardUrl);
        loading.value = false;
        if (boardUrl && data.boards.find((item) => item.url === boardUrl)?.token) {
          // console.log("found a thing");
          executeCanny(
            data.token,
            boardUrl,
            data.boards.find((item) => item.url === boardUrl).token
          );
        } else {
          if (data?.boards?.length) {
            // console.log("couldn't find a thing", data.boards[0].url);
            root.$router.push(`/feedback/${data.boards[0].url}`);
          } else {
            noCanny.value = true;
          }
        }
      });
    });

    return {
      loading,
      noCanny,
    };
  },
};
</script>
